import { RegisterCard } from "../components/RegisterCard";
import { TopAdminNav } from "../layouts/TopAdminNav";
import "../assets/css/main.css";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import {
  MoreVertical,
  Edit,
  ArrowRightLeft,
  UserPlus,
  Trash2,
} from "lucide-react";
import BackButton from "../components/backButton";
import { StaffDataType } from "./StaffData";
import CustomModal from "../components/CustomModal/CustomModal";
import { EditClassForm } from "../layouts/editForms/classroom";
import { defaultUrl } from "../features/actions";
import toast from "react-hot-toast";
import TableLoader from "../components/TableLoader";
import { makeFetchRequest, makePostRequest, makePutRequest, makeDeleteRequest } from "../utilities/common";
import { TransferForm } from "../layouts/editForms/transfer";
import { BiPlus } from "react-icons/bi";
import { AssignStaffToClass } from "../layouts/editForms/AssignStaffToClass";
import Swal from "sweetalert2";

export interface Classroom {
  id: string;
  school_id?: string;
  teachers: StaffDataType[];
  name?: string;
  number_of_students?: number;
  assessment_mode?: "standard_matrix" | "traits_only";
  assessment_type?: "standard" | "standard_matrix" | "traits_only";
  [key: string]: any;
}

export const Classes = () => {
  const [editMode, setEditMode] = useState(false);
  const [editForm, setEditForm] = useState<Classroom>({ id: "", teachers: [] });
  const [isSaving, setIsSaving] = useState(false);
  const [isAssignSaving, setIsAssignSaving] = useState(false);
  const [isTransferSaving, setIsTransferSaving] = useState(false);
  const [classData, setClassData] = useState<{ id: string; name: string }>();
  const [isLoading, setIsLoading] = useState(false);
  const [openTransferModal, setOpenTransferModal] = useState(false);
  const [studentData, setStudentData] = useState([]);
  const user = JSON.parse(sessionStorage.getItem("user") as string);
  const [assignForm, setAssignForm] = useState({
    classroomId: "",
    teacherId: [] as string[],
    name: "",
  });
  const [assignMode, setAssignMode] = useState(false);

  console.log(user);
  const [transferForm, setTransferForm] = useState({
    to_classroom_id: "",
    category: "",
    reason_description: "",
    requested_by_user_id: user?.id || "",
    attachment_path: "",
    student_ids: [] as string[],
  });
  /**DATA FETCHING */
  const [classrooms, setClassrooms] = useState<Classroom[]>([]);
  const [staffData, setStaffData] = useState<StaffDataType[]>([]);

  /** FILTERINGS */
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState(classrooms);

  async function fetchStaffData() {
    const response = await makeFetchRequest(
      `${defaultUrl}/teachers`,
      false,
      true,
    );
    setStaffData(response);
    return response;
  }

  const fetchClassrooms = async () => {
    setIsLoading(true);
    try {
      const response = await makeFetchRequest(`${defaultUrl}/classroom`);
      toast.remove();
      toast.success("Success");
      // console.log(response)
      const staffList = await fetchStaffData();
      const filtered =
        response &&
        response.filter((data: any) => {
          if (!searchTerm.length) {
            return data;
          }
          return data?.name?.toLowerCase().includes(searchTerm.toLowerCase());
        });

      // SORT RESPONSE BY CLASS NAME
      const sortByName =
        filtered &&
        filtered.sort(function (a: any, b: any) {
          return a?.name.localeCompare(b.name);
        });

      const data =
        sortByName &&
        sortByName.map((item: any) => {
          return {
            ...item,
            teachers:
              item.teachers.map(
                (staffID: any) =>
                  staffList &&
                  staffList.find((staff: any) => staff?.id === staffID),
              ) || [],
          };
        });

      setIsLoading(false);

      setFilteredData(data);
      return setClassrooms(data || []);
    } catch (err: any) {
      setIsLoading(false);
      toast.error(
        "Failed to fetch Classrooms, Please refresh this page to try again.",
      );
    }
  };

  useEffect(() => {
    const searchBar = document.getElementById("searchAttendanceInput");
    searchBar?.focus();
    fetchClassrooms();
  }, [searchTerm, isSaving]);

  /** ACTIONS */
  function handleClickEdit(data: any) {
    const isTrait =
      data.assessment_mode === "traits_only" ||
      data.assessment_type === "traits_only";

    setEditForm({
      ...data,
      assessment_mode: isTrait ? "traits_only" : "standard_matrix",
      assessment_type: isTrait ? "traits_only" : "standard_matrix",
    });
    setEditMode(true);
  }
  const handleTransferStudent = (data: any) => {
    setOpenTransferModal(true);
    setClassData(data);
  };

  function handleInputChange({ target: { name, value, files } }: any) {
    setEditForm({
      ...editForm,
      [name]: files ? URL.createObjectURL(files[0]) : value,
    });
    return;
  }
  function handleAssignChange({ target: { name, value, files } }: any) {
    setAssignForm({
      ...assignForm,
      [name]: files ? URL.createObjectURL(files[0]) : value,
    });
    return;
  }
  const handleTransferInputChange = (e: any) => {
    const { name, value } = e.target;

    setTransferForm((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!editForm.name || !editForm.name.trim()) {
      toast.error("Please enter a classroom name");
      return;
    }
    setIsSaving(true);

    const mode =
      editForm.assessment_mode === "traits_only" ||
      editForm.assessment_type === "traits_only"
        ? "traits_only"
        : "standard_matrix";

    // Strictly ensure only clean classroom fields are sent (no psychomotor_skills)
    const payload = {
      name: editForm.name.trim(),
      assessment_mode: mode,
    };

    try {
      await makePutRequest(`${defaultUrl}/classroom/${editForm.id}`, payload);
      fetchClassrooms();
      setEditForm({ id: "", teachers: [] });
      setEditMode(false);
    } catch (error) {
      toast.error("Failed to update classroom");
    } finally {
      setIsSaving(false);
    }
  };
  const handleAssignStaff = async (e: any) => {
    e.preventDefault();
    setIsAssignSaving(true);

    // The payload now sends the full array of selected teacher IDs
    const data = {
      name: classData?.name,
      teachers: assignForm.teacherId,
    };

    try {
      await makePutRequest(`${defaultUrl}/classroom/${classData?.id}`, data);
      toast.success("Staff assigned successfully");
      fetchClassrooms();

      setAssignForm({
        classroomId: "",
        teacherId: [], // Reset to empty array
        name: "",
      });
      setAssignMode(false);
    } catch (error) {
      toast.error("Failed to update staff assignments");
    } finally {
      setIsAssignSaving(false);
    }
  };

  const handleTransfer = async (e: any) => {
    e.preventDefault();
    setIsTransferSaving(true);

    await makePostRequest(`${defaultUrl}/transfer_student`, {
      to_classroom_id: transferForm.to_classroom_id,
      category: transferForm.category,
      reason_description: transferForm.reason_description,
      attachment_path: "transfer_url.jpg",
      requested_by_user_id: transferForm.requested_by_user_id,
      students: transferForm.student_ids, // ✅ send array
    });

    setTransferForm({
      to_classroom_id: "",
      category: "",
      reason_description: "",
      requested_by_user_id: user?.id || "",
      student_ids: [],
      attachment_path: "",
    });

    setOpenTransferModal(false);
    setIsTransferSaving(false);
  };
  const getPupilData = async () => {
    const response = await makeFetchRequest(
      `${defaultUrl}/students/withoutPagination`,
    );
    setStudentData(response);
  };
  useEffect(() => {
    getPupilData();

    // eslint-disable-next-line
  }, []);
  const handleClickTransfer = (data: any) => {
    setClassData(data);
    // Pre-fill with existing IDs
    setAssignForm({
      ...assignForm,
      classroomId: data.id,
      teacherId: data.teachers?.map((t: any) => t?.id).filter(Boolean) || [],
      name: data.name,
    });
    setAssignMode(true);
  };

  const handleDeleteClassroom = (classroom: Classroom) => {
    Swal.fire({
      title: "Delete Classroom?",
      text: `Are you sure you want to delete ${classroom.name || "this classroom"}? This action cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#e11d48",
      cancelButtonColor: "#64748b",
      confirmButtonText: "Yes, Delete",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await makeDeleteRequest(`${defaultUrl}/classroom/${classroom.id}`);
          fetchClassrooms();
        } catch (error) {
          toast.error("Failed to delete classroom");
        }
      }
    });
  };

  return (
    <>
      <div className="w-full flex items-center mb-2">
        <BackButton />
        <TopAdminNav name="Jane Doe" title="Classrooms" />
      </div>

      <div className="flex overflow-y-auto register-scroll mt-2">
        <div className="block w-full h-[90vh] overflow-auto register-scroll">
          {/* Module Banner Deck */}
          <div className="flex">
            <div className="w-full flex items-center md:pr-6">
              <div className="w-full">
                <RegisterCard
                  title="Classroom Management"
                  details="Manage and configure classroom structural units, pupil capacities, and educator assignments."
                  activeDetails="Active Classes"
                  activeNumber={classrooms.length}
                />
              </div>
            </div>
          </div>

          {/* Dynamic Content Table Layout Container */}
          <div className="rounded-2xl border-2 border-gray-100 px-6 py-5 attendance_bg mt-3 mr-4 overflow-y-auto register-scroll bg-white shadow-sm">
            {/* Filter Controls Row Header */}
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6 pb-4 border-b border-gray-100">
              <div className="flex items-center gap-3">
                <Link to="/admin/class/add">
                  <button className="flex items-center gap-2 bg-[#0096D1] hover:bg-[#0085ba] text-white px-5 py-2.5 rounded-xl font-bold text-xs shadow-sm transition-all transform hover:-translate-y-0.5">
                    <BiPlus size={16} />
                    Add Class
                  </button>
                </Link>
                <div className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-xl bg-[#F4F7FE] border border-gray-200/60 text-xs font-bold text-[#012063]">
                  <span>Active Classrooms:</span>
                  <span className="text-[#0096D1] font-black">
                    {filteredData.length}
                  </span>
                </div>
              </div>

              {/* Seamless Integrated Native Search Filtering Bar */}
              <div className="w-full sm:w-72 relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-[#012063AA] text-xs">
                  <FontAwesomeIcon icon={faSearch} />
                </div>
                <input
                  id="searchAttendanceInput"
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Search classroom name..."
                  className="w-full pl-10 pr-4 py-2.5 bg-[#F4F7FE] border-2 border-gray-200 focus:bg-white focus:border-[#0096D1] text-xs font-bold rounded-xl text-[#1f1f1f] placeholder-[#1f1f1f]/[0.4] outline-none transition-all"
                />
              </div>
            </div>

            {/* Section Heading with Dot Indicator */}
            <div className="text-[#012063CC] w-full overflow-x-auto register-scroll animate-fade-in">
              <div className="flex items-center gap-2 mb-3 px-1">
                <span className="h-2 w-2 rounded-full bg-[#0096D1]" />
                <h3 className="text-left text-sm font-black tracking-tight text-slate-700 uppercase">
                  Classroom Storage Index
                </h3>
              </div>

              {/* Pupil Storage Index Style Table */}
              <div className="w-full text-center">
                {/* Premium Table Header Deck */}
                <div className="grid grid-cols-12 w-[98%] !min-w-[700px] mb-3 py-3 px-4 bg-slate-50 text-slate-400 text-[10px] font-bold tracking-wider uppercase border-b border-slate-100 rounded-xl text-left items-center">
                  <div className="col-span-4 pl-2">Class Name</div>
                  <div className="col-span-2 text-center">Pupil Enrollment</div>
                  <div className="col-span-5 text-left pl-4">Assigned Educators</div>
                  <div className="col-span-1 text-right pr-4">Actions</div>
                </div>

                {/* Rows Container */}
                {isLoading ? (
                  <div className="py-12 flex justify-center items-center w-full">
                    <TableLoader />
                  </div>
                ) : filteredData.length > 0 ? (
                  <div className="h-full max-h-[55vh] w-[98%] !min-w-[700px] overflow-y-auto register-scroll pr-1 space-y-2">
                    {filteredData.map((item) => (
                      <div
                        key={item.id}
                        className="grid grid-cols-12 w-full items-center py-3.5 px-4 bg-white border border-slate-100 hover:border-slate-200 hover:shadow-xs rounded-xl transition-all duration-150 text-left text-[13px] font-semibold text-slate-600"
                      >
                        {/* 1. Class Name Block */}
                        <div className="col-span-4 font-bold text-slate-800 truncate capitalize pl-2 flex items-center gap-2">
                          <span className="truncate">{item.name}</span>
                          {item.assessment_mode === "traits_only" || item.assessment_type === "traits_only" ? (
                            <span className="text-[10px] font-black px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 border border-amber-200 shrink-0">
                              Traits Only
                            </span>
                          ) : (
                            <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-200 shrink-0">
                              Standard Matrix
                            </span>
                          )}
                        </div>

                        {/* 2. Pupil Enrollment Badge */}
                        <div className="col-span-2 text-center">
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-md font-mono text-xs bg-slate-100 text-slate-700 border border-slate-200">
                            {item.number_of_students || 0} Pupils
                          </span>
                        </div>

                        {/* 3. Assigned Educators */}
                        <div className="col-span-5 text-left pl-4">
                          {item?.teachers && item.teachers.length > 0 ? (
                            <div className="flex flex-col gap-1">
                              {item.teachers.filter(Boolean).map((teacher: any) => (
                                <span
                                  key={teacher?.id}
                                  className="text-xs font-semibold text-slate-600 flex items-center gap-1.5 truncate"
                                >
                                  <div className="h-1.5 w-1.5 rounded-full bg-emerald-500 shrink-0" />
                                  {teacher?.firstname} {teacher?.surname}{" "}
                                  {teacher?.othername}
                                </span>
                              ))}
                            </div>
                          ) : (
                            <span className="text-xs text-slate-300 font-mono">—</span>
                          )}
                        </div>

                        {/* 4. Modern More Options Dropdown */}
                        <div className="col-span-1 flex justify-end pr-3">
                          <Menu
                            menuButton={
                              <MenuButton
                                className="inline-flex items-center justify-center p-1.5 rounded-lg border border-slate-200 bg-white text-slate-400 shadow-xs hover:text-slate-700 hover:bg-slate-50 hover:border-slate-300 focus:outline-none transition-all duration-150 active:scale-95 cursor-pointer"
                                title="Classroom Options"
                              >
                                <MoreVertical size={15} />
                              </MenuButton>
                            }
                            transition
                            align="end"
                            offsetY={6}
                            menuClassName="absolute right-0 mt-1 w-52 origin-top-right rounded-xl border border-slate-100 bg-white p-1.5 shadow-xl focus:outline-none z-30"
                          >
                            <MenuItem
                              onClick={() => handleClickEdit(item)}
                              className="flex items-center gap-2.5 px-3 py-2 text-xs font-semibold rounded-lg text-slate-700 hover:bg-amber-50 hover:text-amber-700 cursor-pointer transition-colors"
                            >
                              <Edit size={14} className="text-amber-500" />
                              Edit Classroom
                            </MenuItem>

                            <MenuItem
                              onClick={() => handleTransferStudent(item)}
                              className="flex items-center gap-2.5 px-3 py-2 text-xs font-semibold rounded-lg text-slate-700 hover:bg-slate-50 hover:text-slate-900 cursor-pointer transition-colors"
                            >
                              <ArrowRightLeft size={14} className="text-slate-400" />
                              Move Students
                            </MenuItem>

                            <MenuItem
                              onClick={() => handleClickTransfer(item)}
                              className="flex items-center gap-2.5 px-3 py-2 text-xs font-semibold rounded-lg text-slate-700 hover:bg-sky-50 hover:text-[#0096D1] cursor-pointer transition-colors"
                            >
                              <UserPlus size={14} className="text-[#0096D1]" />
                              Assign Staff
                            </MenuItem>

                            <div className="my-1 border-t border-slate-100" />

                            <MenuItem
                              onClick={() => handleDeleteClassroom(item)}
                              className="flex items-center gap-2.5 px-3 py-2 text-xs font-semibold rounded-lg text-rose-600 hover:bg-rose-50 cursor-pointer transition-colors"
                            >
                              <Trash2 size={14} className="text-rose-500" />
                              Delete Classroom
                            </MenuItem>
                          </Menu>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-16 text-slate-400 font-medium text-xs italic bg-white border border-dashed border-slate-200 rounded-xl">
                    No classroom records matched your query system criteria...
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Structural Action Trigger Modals Container */}
      {editMode && (
        <div className="">
          <CustomModal
            title="Edit Classroom"
            width={75}
            children={
              <EditClassForm
                form={editForm}
                handleChange={(e: any) => handleInputChange(e)}
                handleSubmit={handleSubmit}
                isLoading={isSaving}
                onClose={() => setEditMode(false)}
              />
            }
            hideModal={() => setEditMode((prev) => !prev)}
          />
        </div>
      )}
      {openTransferModal && (
        <div className="">
          <CustomModal
            title="Transfer Student"
            width={75}
            children={
              <TransferForm
                form={transferForm}
                handleChange={(e: any) => handleTransferInputChange(e)}
                handleSubmit={handleTransfer}
                isLoading={isTransferSaving}
                studentData={studentData}
                classrooms={classrooms}
                classId={classData?.id ?? ""}
              />
            }
            hideModal={() => setOpenTransferModal((prev) => !prev)}
          />
        </div>
      )}
      {assignMode && (
        <div className="">
          <CustomModal
            title={`Assign Staff to ${classData?.name}`}
            width={75}
            children={
              <AssignStaffToClass
                form={assignForm}
                teachers={staffData}
                handleChange={(e: any) => handleAssignChange(e)}
                handleSubmit={handleAssignStaff}
                isLoading={isAssignSaving}
                classData={classData}
                setForm={setAssignForm}
              />
            }
            hideModal={() => setAssignMode((prev) => !prev)}
          />
        </div>
      )}
    </>
  );
};
